import { createContext, useState, useContext, useEffect } from 'react';

// Create context
const RegionContext = createContext();

/**
 * RegionProvider component to manage the selected region state
 * 
 * @param {Object} props Component props
 * @param {React.ReactNode} props.children Child components
 */
export function RegionProvider({ children }) {
  // Initialize state from localStorage if available, otherwise default to 'washington'
  const [selectedRegion, setSelectedRegion] = useState(() => {
    const savedRegion = localStorage.getItem('selectedRegion');
    return savedRegion || 'washington';
  });

  // Update localStorage when region changes
  useEffect(() => {
    localStorage.setItem('selectedRegion', selectedRegion);
  }, [selectedRegion]);

  // Function to change the selected region
  const changeRegion = (region) => {
    setSelectedRegion(region);
  };

  // Context value
  const value = {
    selectedRegion,
    changeRegion
  };

  return (
    <RegionContext.Provider value={value}>
      {children}
    </RegionContext.Provider>
  );
}

/**
 * Custom hook to use the region context
 * @returns {Object} Region context value
 */
export function useRegion() {
  const context = useContext(RegionContext);
  if (context === undefined) {
    throw new Error('useRegion must be used within a RegionProvider');
  }
  return context;
}

